import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StackPaginatorComponent } from './stack-paginator.component';
import { ButtonModule } from '@airnauts/ng-components/button';


@NgModule({
  declarations: [StackPaginatorComponent],
  imports: [
    CommonModule,
    ButtonModule,
  ],
  exports: [StackPaginatorComponent],
})
export class StackPaginatorModule { }
